import React from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { withStyles } from '@material-ui/core/styles'
import BottomNavigation from '@material-ui/core/BottomNavigation'
import BottomNavigationAction from '@material-ui/core/BottomNavigationAction'
import Visibility from '@material-ui/icons/Visibility'
import { toggleBottomNav } from 'actions/signupForm/addOrEdit'
import styles from 'components/TemplateForm/styles'
import { FileImage, Brush, AirplaneLanding } from 'mdi-material-ui'

export default connect(
  state => ({
    bottomNavigation: state.signupForm.addOrEdit.bottomNav,
    formTypeSelected: state.signupForm.addOrEdit.formTypeSelected,
  }),
  dispatch => bindActionCreators({ toggleBottomNav }, dispatch),
)(
  withStyles(styles)(
    ({ toggleBottomNav, bottomNavigation, classes, formTypeSelected }) => (
      <BottomNavigation
        className={classes.bottomNavNoMargin}
        onChange={(e, payload) => {
          console.log('BottomNavigation onChange')
          // e.preventDefault()
          toggleBottomNav(e, payload)
        }}
        value={bottomNavigation}
        showLabels
        style={{
          display: 'flex',
        }}
      >
        <BottomNavigationAction
          classes={{
            root: classes.bottomNavAction,
            selected: classes.bottomNavActionSelected,
            label: classes.bottomNavLabel,
          }}
          label="Preview"
          icon={<Visibility style={{ color: '#fff' }} />}
        />
        {formTypeSelected !== 'customIntegration' && (
          <BottomNavigationAction
            classes={{
              root: classes.bottomNavAction,
              selected: classes.bottomNavActionSelected,
              label: classes.bottomNavLabel,
            }}
            label="Look & Feel"
            icon={<Brush style={{ color: '#fff' }} />}
          />
        )}
        {formTypeSelected !== 'customIntegration' && (
          <BottomNavigationAction
            classes={{
              root: classes.bottomNavAction,
              selected: classes.bottomNavActionSelected,
              label: classes.bottomNavLabel,
            }}
            label="Logo"
            icon={<FileImage style={{ color: '#fff' }} />}
          />
        )}
        {formTypeSelected !== 'customIntegration' &&
          formTypeSelected !== 'signup' && (
            <BottomNavigationAction
              classes={{
                root: classes.bottomNavAction,
                selected: classes.bottomNavActionSelected,
                label: classes.bottomNavLabel,
              }}
              label="Landing Page"
              icon={<AirplaneLanding style={{ color: '#fff' }} />}
            />
          )}
      </BottomNavigation>
    ),
  ),
)
